/**
 * The header's right-hand mono slot (redesign handoff §3): signed-in email,
 * autosave stamp, or a screen's own note — segments divided by hairlines.
 *
 * Same `useSyncExternalStore` holder pattern as `collabStore.ts`. Screens set
 * it on mount and clear on unmount; the chrome only renders what it is given
 * and never derives session state itself (the tree is the check — App.tsx).
 */
import { useSyncExternalStore } from 'react'

let segments: readonly string[] = []
const listeners = new Set<() => void>()

function emit(next: readonly string[]): void {
  segments = next
  for (const listener of listeners) listener()
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)

  return () => listeners.delete(listener)
}

export function useShellMeta(): readonly string[] {
  return useSyncExternalStore(
    subscribe,
    () => segments,
    () => segments,
  )
}

export function setShellMeta(next: readonly string[]): void {
  if (next.length === segments.length && next.every((s, i) => s === segments[i])) return
  emit(next)
}

export function clearShellMeta(): void {
  if (segments.length > 0) emit([])
}
